/**
 * ReviewDetailsModal Component
 *
 * Modal that displays full review details for an order
 * Shows OrderReviews component in a modal dialog
 */

'use client';

import { Modal } from '@shared/ui';
import type { BaseModalProps } from '@shared/types/modal.types';
import { OrderReviews } from '@/src/features/reviews/ui/OrderReviews';

interface ReviewDetailsModalProps extends BaseModalProps {
  orderId?: string;
  userRole?: 'client' | 'worker';
  orderTitle?: string;
  workerName?: string;
  workerAvatarUrl?: string;
  clientName?: string;
  clientAvatarUrl?: string;
}

/**
 * ReviewDetailsModal - full review details in modal
 */
export function ReviewDetailsModal({
  isOpen,
  onClose,
  orderId,
  userRole = 'client',
  orderTitle,
  workerName,
  workerAvatarUrl,
  clientName,
  clientAvatarUrl,
}: ReviewDetailsModalProps) {
  if (!orderId) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      animation="zoom"
      title={orderTitle || 'Order Reviews'}
      showCloseButton
      closeOnOverlayClick
      closeOnEsc
    >
      <div className="space-y-4">
        <OrderReviews
          orderId={orderId}
          userRole={userRole}
          orderTitle={orderTitle}
          workerName={workerName}
          workerAvatarUrl={workerAvatarUrl}
          clientName={clientName}
          clientAvatarUrl={clientAvatarUrl}
          showExpanded={true}
          onReviewCreated={onClose}
        />
      </div>
    </Modal>
  );
}
